"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGE_SIZE = void 0;
var React = require("react");
var react_table_1 = require("react-table");
require("react-table/react-table.css");
var colors = require("../styles/_colors.scss");
exports.DEFAULT_PAGE_SIZE = 15;
var OnlineTable = /** @class */ (function (_super) {
    __extends(OnlineTable, _super);
    function OnlineTable(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultPageSize = _this.props.defaultPageSize || exports.DEFAULT_PAGE_SIZE;
        _this.state = {
            filterText: '',
            orderBy: [],
            page: _this.props.defaultPageIndex || 0,
            pageSize: _this.defaultPageSize
        };
        // Row click has 4 parametters, is clean this way
        _this.onRowClick = _this.onRowClick.bind(_this);
        return _this;
    }
    OnlineTable.prototype.reset = function () {
        var _this = this;
        this.setState({ filterText: '', orderBy: [], page: 0 }, function () {
            _this.props.onRefresh && _this.props.onRefresh(_this.getSearchParams());
        });
    };
    OnlineTable.prototype.componentWillMount = function () {
        this.props.onRefresh && this.props.onRefresh(this.getSearchParams());
    };
    OnlineTable.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.filterText !== this.props.filterText) {
            this.search({ page: 0 }); // Reseting the page to 1
        }
    };
    OnlineTable.prototype.getSearchParams = function () {
        var loadedLength = this.props.data ? this.props.data.length : 0;
        return __assign(__assign({}, this.state), { filterText: this.props.filterText, loadedLength: loadedLength });
    };
    OnlineTable.prototype.search = function (newParams) {
        var _this = this;
        this.setState(newParams, function () {
            _this.props.onRefresh && _this.props.onRefresh(_this.getSearchParams());
        });
    };
    OnlineTable.prototype.updatePage = function (newParams) {
        var _this = this;
        localStorage.setItem('page', newParams.page.toString());
        this.setState(newParams, function () {
            if (_this.props.data && (_this.state.page + 1) >=
                Math.ceil(_this.props.data.length / _this.state.pageSize + 1)) {
                _this.props.onRefresh && _this.props.onRefresh(_this.getSearchParams());
            }
        });
    };
    OnlineTable.prototype.updatePageSize = function (newParams) {
        var _this = this;
        localStorage.setItem('pageSize', newParams.pageSize.toString());
        this.setState(newParams, function () {
            // Check if we require to get more data once the page increases
            if (_this.props.data && (_this.state.page + 1) * _this.state.pageSize >
                _this.props.data.length && _this.props.data.length < _this.props.total) {
                _this.props.onRefresh && _this.props.onRefresh(_this.getSearchParams());
            }
            if (_this.props.onPageSizeChangeCallback && typeof _this.props.onPageSizeChangeCallback === 'function') {
                _this.props.onPageSizeChangeCallback(newParams.pageSize);
            }
        });
    };
    OnlineTable.prototype.updateOrder = function (columns) {
        if (this.props.freezeSorted && this.props.freezeSorted.length) {
            columns = __spreadArray(__spreadArray([], this.props.freezeSorted, true), columns, true);
        }
        // We already got all the data, no need calling api
        if (this.props.data && this.props.data.length === this.props.total) {
            this.setState({ orderBy: columns, page: 0 });
            return;
        }
        this.search({ orderBy: columns, page: 0 });
    };
    OnlineTable.prototype.onRowClick = function (state, rowInfo, column, instance) {
        var _this = this;
        var style = rowInfo && this.props.rowSelected !== -1 && rowInfo.index === this.props.rowSelected ?
            { background: colors.selectedColor } : {};
        return {
            onClick: function (e, handleOriginal) {
                _this.props.onRowClick && _this.props.onRowClick(rowInfo);
            },
            style: style,
        };
    };
    OnlineTable.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_table_1.default, __assign({}, this.props, { getTdProps: this.onRowClick, defaultFilterMethod: function (filter, row, cfolumn) {
                var id = filter.pivotId || filter.id;
                return row[id] !== undefined ? row[id].toLowerCase().includes(filter.value.toLowerCase()) : true;
            }, pageSizeOptions: [5, exports.DEFAULT_PAGE_SIZE, 30, 50, 100, 200, 500], defaultPageSize: this.defaultPageSize, multiSort: true, sorted: this.state.orderBy, pages: this.props.pages || Math.ceil(this.props.total / this.state.pageSize), page: this.state.page, onPageChange: function (pageIndex) { return _this.updatePage({ page: pageIndex }); }, onPageSizeChange: function (pageSize, pageIndex) { return _this.updatePageSize({ pageSize: pageSize, page: pageIndex }); }, onSortedChange: function (columns, additive) { return _this.updateOrder(columns); }, noDataText: 'Geen data gevonden', previousText: "Vorige", nextText: "Volgende", pageText: "Pagina", ofText: "van", rowsText: "Rijen" })));
    };
    return OnlineTable;
}(React.Component));
exports.default = OnlineTable;
